export default "__VITE_ASSET__AL6fDQdL__"